function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3c00dc",
  strokeWidth: 4.17,
  d: "M231.25 2.083h75V356.25h-75z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.083 297.917v20.833M347.917 252.083V231.25M118.75 339.583V318.75M2.083 277.083V256.25M14.583 247.917h20.834M56.25 247.917h20.833M77.083 260.416v20.834M77.083 302.083v20.833M77.083 343.75v12.5H68.75M47.917 356.25H27.084M6.25 356.25H2.083v-16.667M118.75 297.917v-20.833M118.75 256.251v-20.834M118.75 214.584V193.75M118.75 172.917v-20.834M152.083 143.75H131.25M172.917 143.75h20.833M193.75 156.249v20.834M193.75 197.949v20.583M193.75 239.778v20.523M193.75 281.246v20.763M193.75 323.256v20.462M185.417 356.25h-20.833M143.75 356.25h-20.833M360.417 222.917h20.833M402.083 222.917h20.834M422.917 243.75v20.833M422.917 285.753v20.277M422.917 327.062v20.749M410.231 356.11h-20.647M368.75 356.25h-20.833M347.917 335.417v-20.833M347.917 293.75v-20.833",
  fill: "none",
  stroke: "#3c00dc",
  strokeWidth: 4.17,
  strokeLinejoin: "round",
  strokeMiterlimit: 1.5
});

function SvgChartinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 425 359",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _ref, _ref2);
}

export default SvgChartinline;